import { Injectable, signal, computed, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  signInWithRedirect,
  getRedirectResult,
  GoogleAuthProvider,
  signOut,
} from 'firebase/auth';
import { firstValueFrom } from 'rxjs';
import { User, AuthResponse, ApiResponse } from '../models/interfaces';

const firebaseConfig = {
  apiKey: 'AIzaSyADkZ5RFLGhtbPUGdSSSE08mz8F4JGKARY',
  authDomain: 'qodestudio2-80b20.firebaseapp.com',
  projectId: 'qodestudio2-80b20',
  storageBucket: 'qodestudio2-80b20.firebasestorage.app',
  messagingSenderId: '574839468313',
  appId: '1:574839468313:web:e48cd112cbb836a069d588',
};

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private firebaseAuth;

  currentUser = signal<User | null>(null);
  token = signal<string | null>(null);
  isAuthenticated = computed(() => !!this.currentUser());
  loading = signal(false);

  constructor() {
    const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
    this.firebaseAuth = getAuth(app);
    this.restoreSession();
  }

  private restoreSession() {
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    if (storedToken && storedUser) {
      this.token.set(storedToken);
      this.currentUser.set(JSON.parse(storedUser));
    }
  }

  async handleRedirectResult(): Promise<boolean> {
    try {
      this.loading.set(true);
      const result = await getRedirectResult(this.firebaseAuth);
      if (result?.user) {
        const idToken = await result.user.getIdToken();
        await this.exchangeToken(idToken);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Redirect result error:', error);
      return false;
    } finally {
      this.loading.set(false);
    }
  }

  signInWithGoogle() {
    const provider = new GoogleAuthProvider();
    signInWithRedirect(this.firebaseAuth, provider);
  }

  private async exchangeToken(idToken: string) {
    const response = await firstValueFrom(
      this.http.post<ApiResponse<AuthResponse>>('/v1/auth/google', { idToken })
    );
    const { token, refreshToken, user } = response.data;
    this.token.set(token);
    this.currentUser.set(user);
    localStorage.setItem('token', token);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('user', JSON.stringify(user));
  }

  logout() {
    this.currentUser.set(null);
    this.token.set(null);
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    signOut(this.firebaseAuth);
    this.router.navigate(['/login']);
  }
}
